import { render, staticRenderFns } from "./Pers.vue?vue&type=template&id=757aa11b&scoped=true"
import script from "./Pers.js?vue&type=script&lang=js&external"
export * from "./Pers.js?vue&type=script&lang=js&external"
import style0 from "./Pers.scss?vue&type=style&index=0&id=757aa11b&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "757aa11b",
  null
  
)

export default component.exports